import { AxiosResponse } from 'axios'
import { DataService } from '../../utils/dataService'

import { language } from "../../utils/language";

export const GET_CITIES_AVEONLINE = 'GET_CITIES_AVEONLINE'

export const handleGetCitiesAveonline = (departament: string, url: string) => (dispatch: any) => {

  const data = {
    source: 'shops-integraciones',
    url: url,
    department: departament
  };

  const _dataService = new DataService()
  _dataService
    .post('/applications/integration-clients/get-aveonline-cities', data)
    .then((res: AxiosResponse) => {
      if (res.data.success === true) {
        dispatch({
          type: GET_CITIES_AVEONLINE,
          payload: res.data.data
        })
      }
    })
}

export const GET_AVEONLINE_QUOTATION = 'GET_AVEONLINE_QUOTATION'
export const SET_AVEONLINE_QUOTATION_ERROR = 'SET_AVEONLINE_QUOTATION_ERROR'
export const RESET_AVEONLINE_QUOTATION = 'RESET_AVEONLINE_QUOTATION'

export const handleResetAveonlineQuotation = () => ({
  type: RESET_AVEONLINE_QUOTATION,
})

export const handleGetAveonlineQuotation = (shoppingCartId: string, destinationDaneCode: string, url: string, homelanguage) => (dispatch: any) => {

  const data = {
    source: 'shops-integraciones',
    url: url,
    shoppingCartId: shoppingCartId,
    destinationDaneCode: destinationDaneCode
  };
  const errorMessage = language[homelanguage]["quotationError"]
  const _dataService = new DataService()
  _dataService
    .post('/applications/aveonline/quotation', data)
    .then((res: AxiosResponse) => {
      if (res.data.success === true) {
        dispatch({
          type: GET_AVEONLINE_QUOTATION,
          payload: res.data.data
        })
      } else {
        dispatch({
          type: SET_AVEONLINE_QUOTATION_ERROR,
          payload: errorMessage
        })
      }
    })
    .catch(() => {
      dispatch({
        type: SET_AVEONLINE_QUOTATION_ERROR,
        payload: errorMessage
      })
    })
}